//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ArticleTeaser from "../article-teaser.vue";
import SearchTeaser from "./search-teaser.vue";
import SearchFilter from "./search-filter.vue";
import Dropdown from "../dropdown.vue";
import Utils from "../../utils/utils.js";

import {
    directive as vueOnClickAway
} from "vue-clickaway";
import _ from "lodash";
import qs from "qs";
import Promise from "bluebird";

export default {
    props: {
        search_id: {
            required: true
        },
        post_type: {
             default: ""
        },
        pre_search_text: {
            default: ""
        },
        pre_selected_values: {
            type: Object,
            default: function() {
                return {};
            }
        },
        excluded_filters: {
            default: function() {
                return [];
            }
        },
        included_filters: {
            default: function() {
                return [];
            }
        },
        posts_per_page: {
            default: 12
        },
        order: {
            default: 'DESC',
        },
        order_by: {
            default: 'DATE',
        },
        header_pre_rendered: {},
        header_title: {
            default: ""
        },
        header_description: {
            default: ""
        },
        search_running_text: {
            default: rest_options.options.translations.running
        },
        no_results_found_text: {
            default: rest_options.options.translations.no_results
        },
        upcoming_publications_url: {
            default: rest_options.upcoming
        },
        upcoming_publications_text: {
            default: rest_options.upcomingtext
        },
        from_search: {
            default: false
        },
        big_first_post: {
            default: false
        },
        use_order_by_selection: {
            default: true
        },
        teaser_id: {
            default: ""
        },
        teaser_option: {
            default: ""
        }
    },
    data: function() {
        return {
            initialized: false,
            action: {},
            icons: rest_options.options.icons,
            translations: rest_options.options.translations,
            search_results: [],
            filters: {
                main_filters: [],
                meta_filters: {},
                order_by: ""
            },
            meta_filters: {},
            order_by: false,
            search_text: this.pre_search_text,
            selected_values: this.pre_selected_values,
            run_output: "",
            filters_output: "",
            current_page: 1,
            total_results: 0,
            running_search: true,
            max_number_of_pages: 4,
            debounce_time: 500,
            filters_opened: false,
            max_filters: 4,
            show_all_filters: false,
            search_filters_open: false,
            show_filters_button: false,
            filter_states_before_update: {},
            current_status : "",
            header: {
                header_change_filter: "post_type",
                header_changed: false,
                change_filter_status: {}
            },
            teaser_selection: this.teaser_id,
            teaser_type: this.teaser_option,
            teaser_object: false
        };
    },
    created: function() {
        this.initialize_with_params();
    },
    mounted: function() {
        window.onpopstate = this.go_back_in_history;

        this.init();
        this.update_search().then((response) => {
            this.initialized = true;
        });
    },
    computed: {
        show_all_filters_label_text: function() {
            return this.show_all_filters ?
                this.translations.hide_all_filters :
                this.translations.show_all_filters;
        },
        need_pagination: function() {
            return this.search_results.length < this.total_results;
        },
        page_count: function() {
            return Math.ceil(this.total_results / this.posts_per_page);
        },
        show_article_amount_text: function() {
            return this.translations.showing_articles_amount.replace(
                "%s",
                this.total_results
            );
        },
        use_order_by_filter: function() {
            return this.use_order_by_selection != 0;
        }
    },
    methods: {
        init: function() {
        },
        get_current_status_text : function () {
            return this.current_status
        },
        go_back_in_history : function (event) {
            this.initialize_with_params();

            this.update_search();
        },
        show_filter: function(index) {
            if (!this.show_filters_button) {
                return true;
            }

            if (index < this.max_filters || this.show_all_filters) {
                return true;
            }

            return false;
        },
        filter_state_updated: function() {
            this.current_page = 1;
        },
        is_filter_showing: function(category, filter, index) {
            if (this.is_excluded_filter(category, filter.type, filter.name)) {
                return false;
            }

            if (index != undefined && !this.show_filter(index)) {
                return false;
            }

            return true;
        },
        get_pre_selected_values: function(filter) {
            if (filter == undefined) {
                return this.selected_values;
            }

            if (this.selected_values[filter.type] != undefined) {
                if (this.selected_values[filter.type][filter.name] != undefined) {
                    return this.selected_values[filter.type][filter.name];
                }
            }

            return {};
        },
        remove_filters: function() {
            for (var f in this.$refs.filters) {
                var filter = this.$refs.filters[f];

                if (this.is_filter_showing("main_filters", filter.filter)) {
                    filter.remove_selection();
                }
            }

            this.search_text = "";

            this.update_search();
        },
        filter_opened: function(opened_filter) {
            for (var ref in this.$refs.filters) {
                var filter = this.$refs.filters[ref];

                if (filter != opened_filter) {
                    filter.filter_open = false;
                }
            }
        },
        update_filter_selection: function(type, name, data, filter_button) {
            if (!filter_button) {
                this.debounce_update_search();
            } else {
                _.debounce(this.update_search_filters, this.debounce_time)();
            }
        },
        is_included_filter: function(filter_category, filter_type, filter_name) {
            if (_.isEmpty(this.included_filters)) {
                return false;
            }

            if (this.included_filters[filter_category] == undefined) {
                return false;
            }

            if (this.included_filters[filter_category][filter_type] == undefined) {
                return false;
            }

            return (
                this.included_filters[filter_category][filter_type].indexOf(
                    filter_name
                ) != -1
            );
        },
        is_excluded_filter: function(filter_category, filter_type, filter_name) {
            if (!_.isEmpty(this.included_filters)) {
                return !this.is_included_filter(
                    filter_category,
                    filter_type,
                    filter_name
                );
            }

            if (_.isEmpty(this.excluded_filters)) {
                return false;
            }

            if (this.excluded_filters[filter_category] == undefined) {
                return false;
            }

            if (this.excluded_filters[filter_category][filter_type] == undefined) {
                return false;
            }

            return (
                this.excluded_filters[filter_category][filter_type].indexOf(
                    filter_name
                ) != -1
            );
        },
        change_page: function(page) {
            if (page > this.page_count) {
                page = this.page_count;
            }
            if (page < 1) {
                page = 1;
            }

            if(page == this.current_page - 1) {
                this.current_status = this.translations.moving_to_previous_page;
            } else if (page == this.current_page + 1) {
                this.current_status = this.translations.moving_to_next_page;
            } else {
                this.current_status = this.translations.moving_to_page_x.replace("%1", page);
            }

            this.current_page = page;

            this.debounce_update_search();
        },
        debounce_update_search: _.debounce(function() {
            this.update_search();
        }, this.debounce_time),
        update_search: function() {
            this.running_search = true;

            return this
                .update_search_filters()
                .then(() => {
                    return this.run_search();
                })
                .then(() => {
                    this.running_search = false;
                    this.current_status = this.translations.page_has_been_updated;
                });
        },
        get_selected_values: function() {
            if (!this.initialized && !_.isEmpty(this.get_pre_selected_values())) {
                return this.get_pre_selected_values();
            }

            var selected_filters = {};

            for (var f in this.$refs.filters) {
                var filter = this.$refs.filters[f];

                if (selected_filters[filter.filter.type] == undefined) {
                    selected_filters[filter.filter.type] = {};
                }

                selected_filters[filter.filter.type][
                    filter.filter.name
                ] = filter.get_values();
            }

            return selected_filters;
        },
        run_search: function() {
            return new Promise((resolve, reject) => {
                var selected_values = this.get_selected_values();

                // HACK: replace single quotes with double quotes to have them work as expected
                let search_text = this.search_text.replace(/'/g, '"');

                if (
                    (this.teaser_type === "first_teaser" ||
                        this.teaser_type === "selected_teaser") &&
                    this.current_page == 1
                ) {
                    var posts_per_page = 10;
                } else {
                    var posts_per_page = this.posts_per_page;
                    this.teaser_object = false;
                    this.teaser_selection = false;
                }

                this.$http
                    .get("/wp-json/vtv/v1/search/run?lang=" + rest_options.lang, {
                        params: {
                            selected_filters: selected_values,
                            meta_filters: this.meta_filters,
                            order_by: this.order_by,
                            search_text: search_text,
                            current_page: this.current_page,
                            posts_per_page: posts_per_page,
                            big_first_post: this.big_first_post,
                            included_filters: this.included_filters,
                            exclude_id: this.teaser_selection
                        }
                    })
                    .then(
                        response => {
                            let data = response.body;

                            if (
                                this.teaser_type === "first_teaser" &&
                                this.current_page == 1
                            ) {
                                this.teaser_object = data.posts.shift();
                            }

                            this.search_results = data.posts;
                            this.total_results = data.total_results;

                            if(!window.location.search.length) {
                                window.history.replaceState("", "", this.construct_new_path());
                            } else {
                                window.history.pushState("", "", this.construct_new_path());
                            }

                            resolve(response);
                        },
                        response => {
                            reject(response);
                        }
                    );
            });
        },
        get_current_location_params: function() {
            let current_params = {};

            if (window.location.search.length) {
                var current_params_string = window.location.search;

                current_params = qs.parse(
                    current_params_string.replace(/^(\?|\&)/, "")
                );
            }

            return Utils.convert_object_string_vals(current_params);
        },
        initialize_with_params: function() {
            var current_params = this.get_current_location_params();

            if (current_params.filters != undefined) {
                this.selected_values = current_params.filters;
            }

            if (current_params.meta_filters != undefined) {
                this.meta_filters = current_params.meta_filters;
            }

            if (current_params.page != undefined) {
                this.current_page = current_params.page;
            }
        },
        construct_new_path: function() {
            var additional_params = {
                filters: this.get_selected_values(),
                meta_filters: this.meta_filters,
                page : this.current_page
            };

            if (this.from_search) {
                additional_params["s"] = this.search_text;
            } else {
                additional_params["search_text"] = this.search_text;
            }

            var current_location_params = this.get_current_location_params();

            var new_path =
                window.location.pathname +
                "?" +
                qs.stringify(_.assign(current_location_params, additional_params), {
                    encode: false
                });

            return new_path;
        },
        update_search_filters: function() {
            return new Promise((resolve, reject) => {
                let is_search = this.search_text ? 1 : "";
                this.$http
                    .get(
                        "/wp-json/vtv/v1/search/get_search_filters?lang=" +
                        rest_options.lang, {
                            params: {
                                selected_filters: this.get_selected_values(),
                                current_page: this.current_page,
                                posts_per_page: this.posts_per_page,
                                excluded_filters: this.excluded_filters,
                                is_search: is_search
                            }
                        }
                    )
                    .then(response => {
                        var data = response.body;

                        var main_filters = data.main_filters;

                        var new_allowed_filter_list = {};

                        //Reset the necessary selected filters
                        for (var f in main_filters) {
                            var filter = main_filters[f];

                            if (new_allowed_filter_list[filter.type] == undefined) {
                                new_allowed_filter_list[filter.type] = [];
                            }

                            new_allowed_filter_list[filter.type].push(filter.name);
                        }

                        for (var f in data.meta_filters) {
                            var meta_filter = data.meta_filters[f];

                            if (meta_filter.values) {
                                if (
                                    this.meta_filters[meta_filter.name] == undefined &&
                                    !this.is_excluded_filter(
                                        "meta_filters",
                                        meta_filter.type,
                                        meta_filter.name
                                    )
                                ) {
                                    this.meta_filters[meta_filter.name] =
                                        meta_filter.values[0].value;
                                }
                            }
                        }

                        if (!this.order_by && data.order_by) {
                            var order_by_first = data.order_by[0];
                            this.order_by =
                                order_by_first.field + ":" + order_by_first.direction;
                        }
                        this.filters = data;

                        resolve(response);
                    });
            });
        },
        mobile_filters: function() {
            if (this.search_filters_open) {
                this.search_filters_open = false;
            } else {
                this.search_filters_open = true;
            }
        },
        update_filter_status : function () {
            this.current_status = this.translations.updating_page_content;
        },
        run_filtering: function() {
            this.update_search().then(() => {
                this.search_filters_open = false;
            });
        }
    },
    directives: {
        vueOnClickAway: vueOnClickAway
    },
    components: {
        SearchFilter,
        ArticleTeaser,
        Dropdown,
        SearchTeaser
    }
};



// WEBPACK FOOTER //
// ./js/vue/search/search-module.vue